<template>
  <span>
    <span :class="['right-tab',{'Icon':item.acquiesceType,'curr':initNum==index&&finalSequence[0] == 'right'}]"
          v-show="item.name">
      <img :src="require('../../../assets/image/images/icons/sub_icon_menu_' + (initNum==index&&finalSequence[0] == 'right' ? 'blue.png' : 'black.png'))" />
      <span @click="tabSwitch($event,item)"
            @contextmenu.stop.prevent="tabRight(item,$event)"
            @touchstart.stop="touchstarts(item,$event)"
            @touchmove="touchmoves"
            @touchend="touchends">
        <span :class="['text',{'Icon':item.acquiesceType}]">
          {{item.name}}
        </span>
      </span>
    </span>
    <rightMenu :item="sub"
               v-for="(sub,ind) in tabNav"
               :key="ind"
               :newId="newIds"
               :basicTypes="basicType"
               :newAppId="newAppIds"
               :blockData="blockData"></rightMenu>
  </span>
</template>

<script>
// import $ from 'jquery'
export default {
  name: "rightMenu",
  props: {
    item: Object,
    index: Number,
    newAppId:String,
    blockData: Object,
    finalSequence: Array,
    newId:String,
    basicTypes:Boolean
  },
  data () {
    return {
      tabNav: [],
      twids: 0,
      initNum: 0
    }
  },
  computed:{
    newAppIds(){
      return this.newAppId;
    },
    newIds(){
      return this.newId
    },
    basicType(){
      return this.basicTypes
    }
  },
  //跨级触发方法
  inject: ["fatherMethod", "updateHeight", "tabRight"],
  methods: {
    touchstarts (item, ev) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.tabRight(item, ev);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmoves () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchends () {
      clearTimeout(this.timeOutEvent);
      if (this.timeOutEvent != 0) {
        // 点击事件    
        // this.rightShow = false;
      }
      return false;
    },
    tabSwitch (ev, n) {
      $(ev.target).parents('.outreach_content').find('.right-tab').removeClass('curr');
      $(ev.target).parents('.right-tab').addClass('curr');
      //触发父级点击事件
      this.fatherMethod(n);
      if (n.flowType == 'flow') {
        if (this.tabNav.length) {
          //如果下级有长度，就置空，并且减去长度
          this.updateHeight(-this.twids);
          this.tabNav = [];
        } else {
          // if(this.blockData.flowEnName != 'biz-circle'){
          this.getFlowOrBlockByFlowId(n, ev);
          // }
        }
      }
    },
    getFlowOrBlockByFlowId (item, ev) {
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorDataSpit.json", {
          // appId: this.newAppIds ? this.newAppIds : this.getQuery('appId'),
          appId: this.$appId,
          flowId: item.id,
          diyPageFlowId: '',
          domainNameType: document.location.pathname.split('/')[1],
          isBlock: (this.blockData.flowEnName == 'meta-universe' || this.blockData.flowEnName == 'biz-circle') ? (item.orgType != '-1' ? 'newType' : 'yes') : '',
          userId: this.$store.state.userInfo.userId,
          leftId: this.basicTypes ? '' : this.newId,
          acquiesceType:item.acquiesceType ? item.acquiesceType: '',
          floorEnName:this.blockData.flowEnName
        }).then(res => {
          if (res.data[0].dataArr[0].flowType == 'block' && this.blockData.flowEnName == 'biz-circle') {
            return;
          }
          this.tabNav = res.data[0].dataArr;
          //计算新增宽度并传给父级
          this.twids = res.data[0].dataArr.length * 61;
          this.updateHeight(this.twids);
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.right-tab {
  position: relative;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
  display: block;
  height: 60px;
  line-height: 61px;
  padding-left: 8px;
  font-size: 16px;
}
.text.Icon{
  background: url('../../../assets/image/images/icons/sub_icon_menu_black.png') no-repeat 1px center;
}
.right-tab.curr .Icon{
  background: url('../../../assets/image/images/icons/sub_icon_menu_blue.png') no-repeat 1px center;
}
.photo {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  vertical-align: middle;
  margin-top: -3px;
  padding-right: 5px;
  display: inline-flex;
}
.photo > .z-image .el-image__inner {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
@media screen   and (max-width: 768px) {
  .arrow-box-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  .arrow-box {
    margin: 0;
  }
  // .content-right-box .right-right-tab{width:150px;}
  .content-right-box .cut-normal {
    width: 150px;
  }
  .content-right-box .right-right-tab .right-tab {
    font-size: 14px;
  }
  .content-right-box .right-right-tab .right-tab .text {
    width: 126px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }
  .content-right-box .right-right-tab .right-tab,
  .arrow-box,
  .content-right-box .right-right-tab,
  .content-right-box,
  .content-right-box {
    height: 40px;
    line-height: 40px;
    min-height: 40px;
  }
  .content-right-box .right-right-tab .right-tab .first {
    top: 6px;
  }
  .content-right-box .right-right-tab .right-tab.curr {
    height: 36px;
    line-height: 36px;
    min-height: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/floorBlock/control/rightMenu.vue